const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.farmako.app';

// Set order IDs based on environment
export const PHARMACY_IDS = {
    DELHI: 'a2554ed6-e574-47df-9f5d-e511bf0e48f6',
    MORADABAD: '0857613a-b9e0-4b30-9ea2-1e0da18f64cb',
    GURGAON: '4'
  } 


export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    MEDICINE_SEARCH: '/app/public/internal/b2b-portal/medicine/search',
    MEDICINE_BATCH: '/app/public/internal/b2b-portal/medicine/batch',
    DRAFT: `/app/public/internal/b2b-portal/draft`,
    APPLY_DISCOUNT: (id)=>`/app/public/internal/b2b-portal/channel/${id}/discount`,
    GET_PARTNERS: `/app/public/internal/b2b-portal/channel`,
    CHANNEL_WALLET: (id) => `/app/public/internal/b2b-portal/channel/${id}/wallet`,
    PLACE: '/app/public/internal/b2b-portal/place',
    PLACE_AUTOCOMPLETE: '/app/public/internal/b2b-portal/place/autocomplete',
    PLACE_DETAILS: (placeId) => `/app/public/internal/b2b-portal/place/${encodeURIComponent(placeId)}`,
  }
};

export const getHeaders = (pharmacy_id, channel_id) => {
  const headers = {};

  if (pharmacy_id) {
    headers['x-pharmacy-id'] = pharmacy_id;
  }

  if (channel_id) {
    headers['x-channel-id'] = channel_id;
  }

  return headers;
};